import { render, staticRenderFns } from "./ProgramacionInforme.vue?vue&type=template&id=07243c1c&scoped=true&"
import script from "./ProgramacionInforme.vue?vue&type=script&lang=ts&"
export * from "./ProgramacionInforme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07243c1c",
  null
  
)

export default component.exports